import { GetBasicDtoPagination } from '@customTypes/api/api.types';
import {
    GetProductResponse,
    GetSerialsResponse,
    GetSerialsTransformedResponse
} from '@customTypes/general/product.types';
import { getBasePaginationBody } from '@helpers/getBasePaginationBody';

export const getTransformedDataWithHazard = (response: GetProductResponse) => {
    return {
        ...response,
        data: {
            ...response.data,
            items: response.data?.items?.map((item) => ({
                ...item,
                id: item.partId.toString(),
                hazard: {
                    hazardClassId: item.hazardClassId
                }
            }))
        }
    };
};

export const getSerialsQuery = (dto: GetBasicDtoPagination, url: string) => {
    return {
        url,
        method: 'POST',
        body: getBasePaginationBody({
            ...dto,
            filterFields: [
                'ClientSerial',
                'InboundTicketReferenceNumber',
                'InboundTicketClientItemRef'
            ],
            withoutCaseSensitive: true,
            fixedSorter:
                dto.sorts.field === 'initialInboundDate'
                    ? 'clientSerial'
                    : 'initialInboundDate'
        })
    };
};

export const getTransformedSerialNumbersData = (
    response: GetSerialsResponse
): GetSerialsTransformedResponse => {
    return {
        ...response,
        data: {
            ...response.data,
            items: response.data?.items
                ? response.data?.items.map((item) => ({
                      ...item,
                      id: item.clientSerial.toString(),
                      revisionLevel: item.revisionLevel,
                      expirationDate: item.expirationDate,
                      refurbished: item.refurbished
                  }))
                : []
        }
    };
};
